// Sound played when a new notification arrives (public/Waggex sound.wav).
// Several open tabs play it once: the first one notes the time in localStorage.
// Browsers block sound until the user has clicked the page once; then it's silent.

const SRC = "/Waggex%20sound.wav";
const LAST_KEY = "lecoinvtc.notificationSoundAt";
let audio: HTMLAudioElement | null = null;

export function playNotificationSound(): void {
  try {
    const last = Number(localStorage.getItem(LAST_KEY) || 0);
    if (Date.now() - last < 4000) return; // another tab just played it
    localStorage.setItem(LAST_KEY, String(Date.now()));
  } catch {
    // Storage blocked: play anyway
  }
  audio ??= new Audio(SRC);
  audio.volume = 0.8;
  audio.currentTime = 0;
  audio.play().catch(() => {
    // Autoplay blocked (no click on the page yet)
  });
}
